import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import TimelineEntry from "./TimelineEntry";

/**
 * Stage icons for the timeline header
 */
const STAGE_ICONS = {
  RINSING: "🚿",
  MASHING: "🫧",
  BOILING: "🔥",
  FERMENTATION: "🍺",
  SERVING: "🍻",
  CLEANING: "🧹",
};

/**
 * A collapsible stage group (Mashing, Boiling, etc.)
 */
const TimelineStage = ({ stage, defaultOpen }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  // Auto-expand active stage and collapse non-active stages when active stage changes
  useEffect(() => {
    setIsOpen(defaultOpen);
  }, [defaultOpen]);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  // Determine stage status from entries
  const hasActive = stage.entries.some(
    (e) => e.status === "active" || e.status === "warning",
  );
  const allCompleted = stage.entries.every((e) => e.status === "completed");

  const headerClass = [
    "brew-timeline__stage-header",
    hasActive ? "brew-timeline__stage-header--active" : "",
    allCompleted ? "brew-timeline__stage-header--completed" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="brew-timeline__stage">
      <div className={headerClass} onClick={handleToggle}>
        <div className="brew-timeline__stage-title">
          <span className="brew-timeline__stage-icon">
            {STAGE_ICONS[stage.stage]}
          </span>
          {stage.name}
          {allCompleted && !isOpen && (
            <span
              className="brew-timeline__stage-check"
              style={{ marginLeft: "6px" }}
            >
              ✅
            </span>
          )}
        </div>
        <span
          className={`brew-timeline__stage-chevron ${
            isOpen ? "brew-timeline__stage-chevron--open" : ""
          }`}
        >
          ▼
        </span>
      </div>
      <div
        className={`brew-timeline__entries ${
          isOpen ? "brew-timeline__entries--open" : ""
        }`}
      >
        <div className="brew-timeline__rail">
          {stage.entries.map((entry) => (
            <TimelineEntry key={entry.id} entry={entry} />
          ))}
        </div>
      </div>
    </div>
  );
};

TimelineStage.propTypes = {
  stage: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    stage: PropTypes.string,
    name: PropTypes.string,
    entries: PropTypes.array.isRequired,
  }).isRequired,
  defaultOpen: PropTypes.bool,
  isSessionInactive: PropTypes.bool,
};

export default TimelineStage;
